<style scoped>
    .expand-row{
        margin-bottom: 16px;
    }
</style>
<template>
    <div>
        <Row class="expand-row">
            <Col span="8">
                <span class="expand-key">{{$t("system.Account.telephone")}}</span>
                <span class="expand-value">{{ row.phone }}</span>
            </Col>
            <Col span="8">
                <span class="expand-key">{{$t("system.Account.email")}}</span>
                <span class="expand-value">{{ row.eMail }}</span>
            </Col>
            <Col span="8">
                <span class="expand-key">{{$t("system.Account.qq")}}</span>
                <span class="expand-value">{{ row.qq }}</span>
            </Col>
        </Row>
        <Row>
            <Col span="8">
                <span class="expand-key">{{$t("system.Account.wechat")}}</span>
                <span class="expand-value">{{ row.wechat }}</span>
            </Col>
        </Row>
    </div>
</template>
<script>
  export default {
    props: {
      row: Object
    }
  }
</script>


// WEBPACK FOOTER //
// ExtraRow.vue?e4667306